module.exports = __webpack_public_path__ + "assets/img/baianji.bdd3e155.svg";